import ApiClient from "./../../api/src/ApiClient";

export default {
  namespaced: true,

  state: {
    selectedCurrencyKey: 0,
    currencies: [
      {
        currency: {
          id: 1,
          symbol: "PLN"
        },
        value: 1
      }
    ],
    countries: [],
    invoices: [],
    budgets: [],
    mpks: [],
    settings: []
  },

  getters: {
    selectedCurrency: state => () =>
      state.currencies[state.selectedCurrencyKey],
    clientLimit: state => {
      let property = state.settings.find(s => s.property == "IPH_DEPT");
      return property != null ? property.value : 0;
    }
  },

  mutations: {
    currencies(state, response) {
      state.currencies = response;
    },
    countries(state, response) {
      state.countries = response;
    },
    invoices(state, response) {
      state.invoices = response;
    },
    budgets(state, response) {
      state.budgets = response.map(b => {
        return { edit: false, budget: b };
      });
    },
    mpks(state, response) {
      state.mpks = response.map(b => {
        return { edit: false, mpk: b };
      });
    },
    settings(state, response) {
      state.settings = response;
      let property = state.settings.find(s => s.property == 'IPH_DEPARTMENT');
      let department = property ? property.value : 0;
      this.dispatch("search/setDepartment", department);
    }
  },

  actions: {
    async currencies({ commit, state }) {
      if (state.currencies.length <= 1) {
        let result = await ApiClient.get("api/shop/currencies");
        commit("currencies", result);
      }
    },

    async countries({ commit, state }) {
      if (state.countries.length == 0) {
        let result = await ApiClient.get("api/shop/countries");
        commit("countries", result);
      }
    },

    async invoiceList({ commit, state }, params) {
      let result = await ApiClient.get(
        "api/company/invoices?limit=" +
          params.limit +
          "&offset=" +
          params.offset
      );
      commit("invoices", result);
    },

    async budgets({ commit, state }) {
      let result = await ApiClient.get("api/company/budgets");
      commit("budgets", result);
    },

    async createbudget({ commit, state }, budget) {
      await ApiClient.post("api/company/budget/create", budget);
      this.dispatch("company/budgets");
    },

    async editbudget({ commit, state }, budget) {
      await ApiClient.post("api/company/budget/edit", budget);
      this.dispatch("company/budgets");
    },

    async removebudget({ commit, state }, budget) {
      await ApiClient.post("api/company/budget/remove", budget);
      this.dispatch("company/budgets");
    },

    async mpks({ commit, state }) {
      let result = await ApiClient.get("api/company/mpks");
      commit("mpks", result);
    },

    async creatempk({ commit, state }, mpk) {
      await ApiClient.post("api/company/mpk/create", mpk);
      this.dispatch("company/mpks");
    },

    async editmpk({ commit, state }, mpk) {
      await ApiClient.post("api/company/mpk/edit", mpk);
      this.dispatch("company/mpks");
    },

    async removempk({ commit, state }, mpk) {
      await ApiClient.post("api/company/mpk/delete", mpk);
      this.dispatch("company/mpks");
    },

    async settings({ commit, state }) {
      let result = await ApiClient.get("api/company/settings");
      commit("settings", result);
    },

    async sendMessage({ commit, state }, message) {
      await ApiClient.post("api/shop/message", message);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/company/src/CompanyStore.js